var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('start-layer', {
    attrs: {
      "id": "reviews",
      "clip-waves-class": "purple-gradient px-0",
      "offset": .75
    }
  }, [_c('h4', {
    staticClass: "text-center header-font text-sm-h4 px-3"
  }, [_vm._v(" Thousands of individuals, businesses, charities, schools, and non-profit organizations trust Ellacard ")]), _c('v-carousel', {
    staticClass: "v-carousel-transparent",
    attrs: {
      "light": "",
      "continuous": "",
      "Xcycle": "",
      "height": "auto",
      "show-arrows": false
    }
  }, _vm._l(_vm.reviews, function (r, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "eager": ""
      }
    }, [_c('quote-card', _vm._b({
      staticClass: "absolute-fill px-6"
    }, 'quote-card', r, false)), _c('div', {
      staticClass: "overflow-auto d-flex",
      staticStyle: {
        "opacity": "0",
        "padding-bottom": "50px",
        "pointer-events": "none",
        "z-index": "-1"
      },
      style: {
        width: 100 * _vm.reviews.length + '%'
      }
    }, _vm._l(_vm.reviews, function (r) {
      return _c('div', {
        style: {
          width: 100 * _vm.reviews.length + '%'
        }
      }, [_c('quote-card', _vm._b({
        staticClass: "px-6"
      }, 'quote-card', r, false))], 1);
    }), 0)], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }